/* eslint-disable react-hooks/rules-of-hooks */
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useUser } from './Context/UserContext';
import profileImg from "../assets/logo.png";
import ViewAllVendors from "./ViewAllVendors";
import "../styles/ViewAllInvoice.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";


const ViewAllInvoicesPO = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null); // or invoice
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("history"); // or "history"
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [subTab, setSubTab] = useState("details");
    //const [isEditing, setIsEditing] = useState(false);
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [verifierError, setVerifierError] = useState("");
    const [emailApprovalError, setemailApprovalError] = useState("");
    const [poError, setpoError] = useState("");
    const [prError, setprError] = useState("");
    const [quotationError, setquotationError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(3);
    const { user: loggedInUser } = useUser();
    const [users, setUsers] = useState([]);
    const { user } = useUser();
    const [approverId, setApproverId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchInput, setSearchInput] = useState(""); // raw field value (debounced into searchTerm)
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [verifiers, setVerifiers] = useState([]);
    const [files, setFiles] = useState({});
    const [vendorFiles, setVendorFiles] = useState({});
    const [poFiles, setPoFiles] = useState({});
    const [formData, setFormData] = useState({});
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [approvalDetails, setApprovalDetails] = useState(null);
    const [backendStatus, setBackendStatus] = useState(null);
    const FINAL_STATUSES = [8, 6, 7];
    const status = selectedInvoice?.approvalStatus;
    const isFinalStatus = FINAL_STATUSES.includes(backendStatus);
    const approvalStatus = String(selectedInvoice?.approvalStatus || "");
    const isApproved = approvalStatus === "1" || backendStatus === 8 || backendStatus === 28;
    const isRejected = approvalStatus === "2" || backendStatus === 6 || backendStatus === 7;
    const isInitial = approvalStatus === "";
    const [approvedInvoices, setApprovedInvoices] = useState([]);
    const [rejectedInvoices, setRejectedInvoices] = useState([]);
    const isAgreement = String(invoiceInfo?.pono || "").trim().toLowerCase() === "agreement";
    //const isApproved = String(selectedInvoice?.approvalStatus) === "1";
    //const isRejected = String(selectedInvoice?.approvalStatus) === "2";
    <ViewAllVendors
        activeTab={activeTab}
        subTab={subTab}
        setSubTab={setSubTab}
        isEditing={isEditing}
        selectedVendor={selectedInvoice} // can rename internally if needed
        //handleInputChange={handleInputChange}
        setIsEditing={setIsEditing}
    />

    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);

    const approvalDataLoaded = useRef(false);


    const handleReviewClick = async (index) => {
        approvalDataLoaded.current = false;  // ✅ add this line

        const selected = invoices[index];
        if (!selected) return;
        setSelectedInvoice(null);
        setInvoiceInfo(null);
        setVendorInfo(null);
        setFiles({});
        setPoFiles({});
        setApprovalDetails([]);
        setComment("");
        setBackendStatus(null);
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setSelectedInvoice({
            ...selected,
            index
        });
        //setSelectedInvoice({
        //    ...selected,
        //    index,
        //    approvalStatus: "",      // important
        //    rejectionSendTo: "",     // important
        //});
        
        setActiveTab("infoInvoice"); // open Invoice Info tab

        try {
            // Fetch invoice info by invoice ID
            const invoiceRes = await axios.get(
                `/api/invoices/info/${selected.id}`
            );

            const invoiceData = invoiceRes.data;

            setInvoiceInfo(invoiceData); // ✅ correct

            const userId = invoiceData?.userid;
            console.log(">>> selectedInvoice full object:", selectedInvoice); // ✅ add this
            console.log(">>> Sending ID to API:", selectedInvoice.id);        
            axios.get(`/api/supplier/invoice-approval-data/${selectedInvoice.id}`)
                .then((res) => {
                    const data = res.data;
                    console.log(">>> departmentHeads:", data.departmentHeads);
                    console.log(">>> verifiers:", data.verifiers);
                    console.log(">>> full response:", data);

                    setDepartmentHeads(data.departmentHeads || []);
                    setVerifiers(data.verifiers || []);
                })

            if (!userId) {
                alert("User ID not available!");
                return;
            }

            // Fetch vendor info using userid from invoice info
            const vendorRes = await axios.get(
                `/api/vendordetails/vendor-by-userid/${invoiceData.userid}`
            );
            const vendorData = { ...vendorRes.data, id: vendorRes.data.vendorId };
            setSelectedVendor(vendorData);

            // Fetch vendor files
            const filesRes = await axios.get(
                `/api/vendor/files/vendor/${vendorData.vendorId}`
            );

            const filesMapped = {};
            filesRes.data.forEach((file) => {
                const key = file.docName.toUpperCase();
                filesMapped[key] = {
                    fileId: file.fileId,
                    fileName: file.fileName,
                    fileExtension: file.fileExtension,
                    filePath: `/api/vendor/files/${file.fileId}?mode=view`,
                };
            });
            setFiles(filesMapped);

            setShowModal(true);

        } catch (err) {
            console.error("Error fetching invoice or vendor info:", err);
            setSelectedVendor(null);
            setFiles({});
            
        }
    };



    useEffect(() => {
        if (invoiceInfo?.userid) {
            axios
                .get(`/api/vendordetails/vendor-by-userid/${invoiceInfo.userid}`)
                .then((res) => {
                    console.log("Vendor Info:", res.data);
                    setVendorInfo(res.data);
                    setSelectedVendor(res.data);
                })
                .catch((err) => {
                    console.error("Error fetching vendor info", err);
                    setVendorInfo(null);
                });
        }
    }, [invoiceInfo]);


    useEffect(() => {
        if (!selectedVendor?.vendorId) return;

        axios
            .get(`/api/vendor/files/vendor/${selectedVendor.vendorId}`)
            .then((res) => {
                const filesMapped = {};
                res.data.forEach((file) => {
                    const key = file.docName.toUpperCase(); // PAN, GST, MSME, CHEQUE
                    filesMapped[key] = {
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileExtension: file.fileExtension,
                        filePath: `/api/vendor/files/${file.fileId}?mode=view`, // preview link
                    };
                });
                setFiles(filesMapped);
            })
            .catch((err) => {
                console.error("Error fetching vendor files:", err);
                setFiles({});
            });
    }, [selectedVendor]);


    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;

        if (selectedFiles && selectedFiles.length > 0) {
            setFiles((prev) => ({
                ...prev,
                [name]: selectedFiles[0]
            }));
        }
        if (name === "PO") {
            setpoError("");
        }

        if (name === "PR") {
            setprError("");
        }
    };

    const statusMapping = {
        Pending: 3,
        Rejected: 2,
        Approved: 1
    };
    const mapBackendToUIStatus = (status) => {
        switch (status) {
            case 8:
            case 28:
                return "1"; // Approved
            case 6:
            case 7:
                return "2"; // Rejected
            default:
                return "";
        }
    };
    const mapRejectionSendTo = (status) => {
        if (status === 6) return "4"; // Security
        if (status === 7) return "5"; // vendor
        return "";
    };
    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const res = await axios.get(
                    "/api/invoices/list",
                    {
                        params: {
                            statusId: selectedStatus,
                            search: searchTerm || ""
                        }
                    }
                );

                console.log("Selected Status:", selectedStatus);
                console.log("Response:", res.data);

                setInvoices(res.data || []);
            } catch (err) {
                console.error("Error fetching invoices:", err);
                setInvoices([]);
            }
        };

        fetchInvoices();
    }, [selectedStatus, searchTerm]);
   

    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });

        setInvoices(sortedInvoices);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const invoicesPerPage = 6;

    // Debounce the search field (300ms) → commits into searchTerm (drives the API fetch)
    useEffect(() => {
        const handle = setTimeout(() => {
            setSearchTerm(searchInput);
            setCurrentPage(1);
        }, 300);
        return () => clearTimeout(handle);
    }, [searchInput]);

    const [historyData, setHistoryData] = useState([]);

  
    useEffect(() => {
        if (!selectedInvoice?.id) return;

        console.log("Invoice ID being sent:", selectedInvoice.id);

        axios
            .get(`/api/invoices/approval-history/${selectedInvoice.id}`)
            .then((res) => {
                console.log("APPROVAL HISTORY:", res.data);
                setHistoryData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching approval history:", err);
                setHistoryData([]);
            });

    }, [activeTab, selectedInvoice]);

    //useEffect(() => {
    //    if (activeTab !== "infoInvoice") return;
    //    if (!selectedInvoice?.invoiceNo) return;

    //    axios
    //        .get(`/api/invoices/info/${selectedInvoice.invoiceNo}`)
    //        .then((res) => {
    //            console.log("Invoice Info:", res.data);
    //            setInvoiceInfo(res.data);
    //        })
    //        .catch((err) => {
    //            console.error("Error fetching invoice info:", err);
    //        });

    //}, [activeTab, selectedInvoice?.invoiceNo]);
    useEffect(() => {
        if (activeTab !== "infoInvoice") return;

        const invoiceId = selectedInvoice?.id || selectedInvoice?.ID;
        if (!invoiceId) return;

        axios
            .get(`/api/invoices/info/${invoiceId}`)
            .then((res) => {
                console.log("Invoice Info:", res.data);
                setInvoiceInfo(res.data); // <-- use res.data directly
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
            });

    }, [activeTab, selectedInvoice]);

    // Pagination
    const totalPages = Math.ceil(invoices.length / invoicesPerPage);
    const startIndex = (currentPage - 1) * invoicesPerPage;
    const currentInvoices = invoices.slice(startIndex, startIndex + invoicesPerPage);
   

    const handlePageChange = (action) => {
        if (action === "first") setCurrentPage(1);
        else if (action === "prev" && currentPage > 1) setCurrentPage(prev => prev - 1);
        else if (action === "next" && currentPage < totalPages) setCurrentPage(prev => prev + 1);
        else if (action === "last") setCurrentPage(totalPages);
    };

    

    useEffect(() => {
        axios
            .get("/api/supplier/supplier-types")
            .then((res) => {
                setSupplierTypes(res.data);
            })
            .catch((err) => {
                console.error("Error fetching supplier types:", err);
                setSupplierTypes([]);
            });
    }, []);

    useEffect(() => {
        if (!selectedInvoice?.id || !showModal) return;
        if (approvalDataLoaded.current) return;  // ✅ skip if already loaded

        approvalDataLoaded.current = true;  // ✅ mark as loaded

        axios.get(`/api/supplier/invoice-approval-data/${selectedInvoice.id}`)
            .then((res) => {
                const data = res.data;

                console.log("Dept heads:", data.departmentHeads);
                console.log("Verifiers:", data.verifiers);

                setDepartmentHeads(data.departmentHeads || []);
                setVerifiers(data.verifiers || []);

                setSelectedInvoice((prev) => ({
                    ...prev,
                    supplierType: data.supplierType ? String(data.supplierType) : "",
                    departmentHead: data.departmentHeadId || "",
                    verifier: data.verifierId || ""
                }));
            })
            .catch((err) => {
                console.error("❌ Error loading approval data:", err);
            });

    }, [selectedInvoice?.id, showModal]);


    const handleSaveStatus = async () => {
        if (backendStatus === 8 || backendStatus === 6 || backendStatus === 7) {
            return;
        }

        let isValid = true;

        // Clear previous errors
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setSupplierTypeError("");
        setDepartmentHeadError("");
        setemailApprovalError("");
        setpoError("");
        setprError("");
        setVerifierError("");

        // Approval required
        if (
            String(selectedInvoice?.approvalStatus) !== "1" &&
            String(selectedInvoice?.approvalStatus) !== "2"
        ) {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }

        if (!comment?.trim()) {
            setCommentError("This field is required");
            isValid = false;
        }

        if (isRejected) {
            if (!selectedInvoice?.rejectionSendTo) {
                setRejectionSendToError("This field is required");
                isValid = false;
            }
        }

        if (isApproved) {
            if (!selectedInvoice?.supplierType) {
                setSupplierTypeError("This field is required");
                isValid = false;
            }

            if (!selectedInvoice?.departmentHead) {
                setDepartmentHeadError("This field is required");
                isValid = false;
            }

            if (!isAgreement && !files.PO) {

                setpoError("This field is required");

                isValid = false;

            }

            if (!isAgreement && !files.PR) {

                setprError("This field is required");

                isValid = false;

            }
        }

        if (!isValid) return;

        try {
            const approverId = user?.empId?.toString();

            if (!approverId) {
                alert("Approver ID missing.");
                return;
            }

            const formData = new FormData();

            // Basic fields
            formData.append("InvoiceId", selectedInvoice.id);
            formData.append("ApprovalStatus", Number(selectedInvoice.approvalStatus));
            formData.append("Comments", comment);
            formData.append("ApprovedBy", approverId);

            // Rejected
            if (selectedInvoice.approvalStatus === "2") {
                formData.append("SendTo", Number(selectedInvoice.rejectionSendTo));
            }

            // Approved
            if (selectedInvoice.approvalStatus === "1") {
                formData.append("DepartmentHead", selectedInvoice.departmentHead);
                formData.append("SupplierType", Number(selectedInvoice.supplierType));
                formData.append("VerifierID", selectedInvoice.verifier);

                if (files.EmailApproval)
                    formData.append("EmailApproval", files.EmailApproval);

                if (files.PO)
                    formData.append("PO", files.PO);

                if (files.PR)
                    formData.append("PR", files.PR);

                if (files.Quotation1)
                    formData.append("Quotation1", files.Quotation1);

                if (files.Invoice)
                    formData.append("Invoice", files.Invoice);

                if (files.ComparisonQuotes)
                    formData.append("ComparisonQuotes", files.ComparisonQuotes);

                if (files.VendorEvaluationForm)
                    formData.append("VendorEvaluationForm", files.VendorEvaluationForm);

                if (files.Quotation2)
                    formData.append("Quotation2", files.Quotation2);

                if (files.Quotation3)
                    formData.append("Quotation3", files.Quotation3);

                if (files.OtherDocuments)
                    formData.append("OtherDocuments", files.OtherDocuments);
            }

            const response = await axios.post(
                "/api/invoice/po-approval",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (response.status === 200) {

                // 🔥 IMPORTANT: check backend success flag
                if (!response.data?.success) {
                    alert(response.data?.message || "Something failed");
                    return;
                }

                alert(response.data.message || "Saved successfully");

                // ✅ Remove from Pending list
                setInvoices(prev =>
                    prev.filter(inv => inv.id !== selectedInvoice.id)
                );

                // ✅ Prepare updated object
                let updatedInvoice = { ...selectedInvoice };

                if (selectedInvoice.approvalStatus === "1") {
                    // APPROVED
                    updatedInvoice.approvalStatus =
                        "Approved by PO, Pending from Verifier";
                    updatedInvoice.backendStatus = 8;

                    setApprovedInvoices(prev => [...prev, updatedInvoice]);

                } else if (selectedInvoice.approvalStatus === "2") {
                    // REJECTED
                    updatedInvoice.approvalStatus =
                        selectedInvoice.rejectionSendTo === "4"
                            ? "Rejected by PO, Pending from Security"
                            : "Rejected by PO, Pending from Vendor";

                    updatedInvoice.backendStatus = 6;

                    setRejectedInvoices(prev => [...prev, updatedInvoice]);
                }

                setComment("");
                setShowModal(false);
            }

        } catch (error) {
            console.error("Full error:", error.response?.data);

            const errorMessage =
                error?.response?.data?.message ||   // ✅ correct key from backend
                error?.response?.data?.error ||     // fallback if different API
                error?.message ||                   // axios/network error
                "Something went wrong";

            alert(errorMessage);
        }
    };

    useEffect(() => {

        if (!selectedInvoice?.id || !showModal) return;

        // Reset old data
        setApprovalDetails([]);
        setComment("");
        setPoFiles({
            evaluationForm: "",
            comparisonQuotes: "",
            emailApproval: "",
            invoice: "",
            po: "",
            pr: "",
            quotation1: "",
            quotation2: "",
            quotation3: "",
            otherDocuments: ""
        });

        const fetchApprovalDetails = async () => {

            try {

                const res = await axios.get(
                    `/api/invoice/approval-details/${selectedInvoice.id}`
                );

                console.log("Approval API response:", res.data);

                const approvalsArray = res.data.invoiceApprovalsHistoryDto ?? [];
                setApprovalDetails(Array.isArray(approvalsArray) ? approvalsArray : []);

                const invoiceDetails = res.data.invoiceDetails;

                if (invoiceDetails) {
                    setBackendStatus(invoiceDetails.approvalStatus);
                }

                const latestApproval = approvalsArray[0];

                if (latestApproval) {

                    const mappedStatus = mapBackendToUIStatus(latestApproval.status);

                    setSelectedInvoice(prev => ({
                        ...prev,
                        approvalStatus: mappedStatus,
                        rejectionSendTo: mapRejectionSendTo(latestApproval.status),
                        approvalStatusText: latestApproval.statusText
                    }));

                    // Show comment only for final statuses
                    if ([8, 6, 7].includes(latestApproval.status)) {
                        setComment(latestApproval.comments || "");
                    }
                }

                const poDocs = res.data.poDocuments || {};

                if ([8, 6, 7].includes(invoiceDetails?.approvalStatus)) {

                    setPoFiles({
                        evaluationForm: poDocs.evaluationForm ?? "",
                        comparisonQuotes: poDocs.comparisonQuotes ?? "",
                        emailApproval: poDocs.emailApproval ?? "",
                        invoice: poDocs.invoice ?? "",
                        po: poDocs.po ?? "",
                        pr: poDocs.pr ?? "",
                        quotation1: poDocs.quotation1 ?? "",
                        quotation2: poDocs.quotation2 ?? "",
                        quotation3: poDocs.quotation3 ?? "",
                        otherDocuments: poDocs.otherDocuments ?? ""
                    });

                } else {

                    // Pending → clear files
                    setPoFiles({
                        evaluationForm: "",
                        comparisonQuotes: "",
                        emailApproval: "",
                        invoice: "",
                        po: "",
                        pr: "",
                        quotation1: "",
                        quotation2: "",
                        quotation3: "",
                        otherDocuments: ""
                    });

                }

            } catch (err) {
                console.error("Error fetching approval details:", err);
                setApprovalDetails([]);
            }

        };

        fetchApprovalDetails();

    }, [selectedInvoice?.id, showModal]);

  
    
    
    //const renderDocumentFile = (fileData, fileName, title) => {

    //    console.log("Received fileData:", fileData); // 🔥 DEBUG

    //    if (!fileData || fileData.trim() === "") {
    //        return <span style={{ color: "gray" }}>No file uploaded</span>;
    //    }

    //    let fileUrl = "";

    //    if (fileData.startsWith("http")) {
    //        fileUrl = fileData;
    //    } else if (fileData.startsWith("JVBER")) {
    //        fileUrl = `data:application/pdf;base64,${fileData}`;
    //    } else {
    //        fileUrl = `${BASE_URL}${fileData}`;
    //    }

    //    console.log("Final URL:", fileUrl); // 🔥 VERY IMPORTANT

    //    return (
    //        <div style={{ display: "flex", flexDirection: "column" }}>
    //            <span style={{ color: "#0a4275", fontWeight: "500" }}>
    //                {fileName || fileData.split("/").pop()}
    //            </span>

    //            <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
    //                <Button
    //                    color="primary"
    //                    size="sm"
    //                    outline
    //                    onClick={() => {
    //                        setPreviewUrl(fileUrl);
    //                        setPreviewTitle(title);
    //                        setShowPreview(true);
    //                    }}
    //                >
    //                    View
    //                </Button>

    //                <a
    //                    href={fileUrl}
    //                    target="_blank"
    //                    rel="noopener noreferrer"
    //                    className="btn btn-sm btn-outline-success"
    //                >
    //                    Download
    //                </a>
    //            </div>
    //        </div>
    //    );
    //};

    const BASE_URL = "";

    const renderDocumentFile = (fileData, fileName, title) => {

        if (!fileData || typeof fileData !== "string" || fileData.trim() === "") {
            return <span style={{ color: "gray" }}>No file uploaded</span>;
        }

        let fileUrl = "";
        let cleanPath = fileData.trim();

        // 🔥 Fix backslashes (Windows paths)
        cleanPath = cleanPath.replace(/\\/g, "/");
        cleanPath = cleanPath.replace(/^~\/?/, ""); 
        // 🔥 Fix wrong folder case (VERY IMPORTANT)
        cleanPath = cleanPath.replace(/^invoicecopy/i, "InvoiceCopy");

        // ✅ Valid full URL
        if (cleanPath.startsWith("http")) {

            // ❌ Fix wrong host like http://invoicecopy/...
            if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
                fileUrl = cleanPath;
            } else {
                fileUrl = `${BASE_URL}/${cleanPath.replace(/^\/+/, "")}`;
            }
        }

        // ✅ Base64 PDF
        else if (cleanPath.startsWith("JVBER")) {
            fileUrl = `data:application/pdf;base64,${cleanPath}`;
        }

        // ✅ Relative path
        else {
            fileUrl = `${BASE_URL.replace(/\/$/, "")}/${cleanPath.replace(/^\/+/, "")}`;
        }

        console.log("Final File URL:", fileUrl); // 🔥 DEBUG

        const displayName =
            fileName ||
            (cleanPath.includes("/") ? cleanPath.split("/").pop() : "Document");

        return (
            <div className="doc-file" style={{ display: "flex", flexDirection: "column" }}>

                {/* File Name */}
                <span className="doc-file-name" style={{ color: "#0a4275", fontWeight: "500" }}>
                    {displayName}
                </span>

                {/* Buttons */}
                <div className="doc-actions" style={{ display: "flex", gap: "8px", marginTop: "5px" }}>

                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => {
                            console.log("Clicked View", fileUrl);
                            setPreviewUrl(fileUrl);
                            setPreviewTitle(title);
                            setShowPreview(true);
                        }}
                    >
                        View
                    </Button>

                   
                </div>
            </div>
        );
    };
    return (
         <>
            <style>{`
                @keyframes msmeBlink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.25; }
                }
                .msme-star-blink {
                    animation: msmeBlink 1.2s ease-in-out infinite;
                }
            `}</style>
        <DashboardLayout>
        <div className="invoice-container">
                <h2 className="invoice-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '25px' }}>Invoice Approval Details</h2>
                <div className="vendor-toolbar">
                    {/* 🔹 Search Box — Left Side */}
                    <div className="vendor-toolbar-search">
                        <div className="vendor-search-box invoice-search-box">
                            <span className="vendor-search-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </span>
                            <Input
                                type="text"
                                placeholder="Search by Company Name..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                aria-label="Search by company name"
                                className="vendor-search-input"
                            />
                            {searchInput && (
                                <button
                                    type="button"
                                    className="vendor-search-clear"
                                    aria-label="Clear search"
                                    onClick={() => setSearchInput("")}
                                >
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* 🔹 Status Dropdown — Right Side */}
                    <div className="vendor-status-filter">
                        <label className="vendor-status-label">
                            Approved Status:
                        </label>

                        <Input
                            type="select"
                            className="vendor-status-select"
                            value={selectedStatus}
                            onChange={(e) => {
                                setSelectedStatus(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={statusMapping.Pending}>⏳ Pending</option>
                            <option value={statusMapping.Approved}>✔️ Approved</option>
                            <option value={statusMapping.Rejected}>❌ Rejected</option>
                        </Input>
                    </div>
                </div>

            <div className="invoice-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="invoice-table invoice-table-po">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Company Name</th>
                            <th>Invoice Type</th>
                            <th>Supplier Type</th>
                        <th>Invoice No</th>
                            <th>Total Value</th>
                            <th>DC Number</th>
                        <th>Create Date</th>
                                <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                    Approval Status {sortBy === "approvalStatus"
                                        ? (sortOrder === "asc" ? "▲" : "▼")
                                        : "⇅"}
                                </th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentInvoices.map((invoice, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px"
                                }}>
                                    {invoice.msmeNo && (
                                        <span
                                            title={`MSME: ${invoice.msmeNo}`}
                                            className="msme-star-blink"
                                            style={{
                                                position: "relative",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "54px",
                                                height: "50px"
                                            }}
                                        >
                                            ⭐ MSME
                                        </span>
                                    )}
                                    <span>{invoice.nameOfCompany}</span>
                                </div>
                            </td>
                            <td>{invoice.invoiceType}</td>
                            <td>{invoice.supplierType}</td>
                            <td>{invoice.invoiceNo}</td>
                            <td>{invoice.totalValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                            <td>{invoice.dcnumber}</td>
                            <td>{invoice.createdDate}</td>
                            <td>{invoice.approvalStatus}</td>
                            <td>
                                <button className="review-btn" onClick={() => handleReviewClick(index)}>
                                    Review
                                </button>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
            </div>

            <div className="pagination">
                <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                <span className="page-info">Page {currentPage} of {totalPages}</span>
                <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
            </div>
                </div>
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="invoice-details-modal">
                    <ModalHeader toggle={() => setShowModal(false)}>Invoice Details</ModalHeader>
                    <div className="tabs1">
                        <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Vendor Info</span>
                        <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Invoice Approval History</span>
                        <span className={activeTab === "infoInvoice" ? "active-tab" : ""} onClick={() => setActiveTab("infoInvoice")}>Invoice Info</span>
                        <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>

                    </div>
                    <ModalBody>
                        {activeTab === "details" && (
                        <>
                                <Table bordered className="info-table1">
                                <tbody>

                                    {/* Company */}
                                    <tr>
                                        <th><strong>Name of Company:</strong></th>
                                        <td>{selectedInvoice?.nameOfCompany || "N/A"}</td>
                                        <th></th>
                                        <td></td>
                                    </tr>

                                    {/* Approval + Comments */}
                                    {/* ================= APPROVAL + COMMENTS ================= */}
                                    {/*<tr>*/}
                                    {/*    <th>*/}
                                    {/*        <strong>Approval Status:</strong>*/}
                                    {/*        <span className="required-field">*</span>*/}
                                    {/*    </th>*/}
                                    {/*    <td>*/}
                                    {/*        <Input*/}
                                    {/*            type="select"*/}
                                    {/*            value={String(selectedInvoice?.approvalStatus || "")}*/}
                                    {/*            disabled={isFinalStatus}*/}
                                    {/*            onChange={(e) => {*/}
                                    {/*                setSelectedInvoice({*/}
                                    {/*                    ...selectedInvoice,*/}
                                    {/*                    approvalStatus: e.target.value*/}
                                    {/*                });*/}
                                    {/*                setApprovalStatusError("");*/}
                                    {/*            }}*/}
                                    {/*        >*/}
                                    {/*            <option value="">Select</option>*/}
                                    {/*            <option value="1">Approved</option>*/}
                                    {/*            <option value="2">Rejected</option>*/}
                                    {/*        </Input>*/}
                                    {/*        {!isFinalStatus && approvalStatusError && (*/}
                                    {/*            <div className="text-danger">{approvalStatusError}</div>*/}
                                    {/*        )}*/}
                                    {/*    </td>*/}
                                    <tr>
                                        <th>
                                            <strong>Approval Status:</strong>
                                            <span className="required-field">*</span>
                                        </th>
                                        <td>
                                            {isFinalStatus ? (
                                                backendStatus === 8 || backendStatus === 28
                                                    ? "Approved"
                                                    : backendStatus === 6 || backendStatus === 7
                                                        ? "Rejected"
                                                        : "N/A"
                                            ) : (
                                                <>
                                                        <Input
                                                            type="select"
                                                            value={status}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                setSelectedInvoice(prev => ({
                                                                    ...prev,
                                                                    approvalStatus: value,
                                                                    rejectionSendTo: value === "2" ? prev.rejectionSendTo : "" // ✅ clear when not rejected
                                                                }));

                                                                setApprovalStatusError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1">Approved</option>
                                                            <option value="2">Rejected</option>
                                                        </Input>

                                                            {approvalStatusError && (
                                                                <div className="text-danger">{approvalStatusError}</div>
                                                            )}
                                                        </>
                                                    )}
                                                </td>
                                             <th>            
                                            <strong>Comments:</strong>
                                            <span className="required-field">*</span>
                                        </th>
                                        <td>
                                            <Input
                                                type="textarea"
                                                value={comment || ""}
                                                disabled={isFinalStatus}
                                                onChange={(e) => {
                                                    setComment(e.target.value);
                                                    setCommentError("");
                                                }}
                                            />
                                            {!isFinalStatus && commentError && (
                                                <div className="text-danger">{commentError}</div>
                                            )}
                                        </td>
                                    </tr>

                                    {!isApproved && (
                                        <tr>
                                            <th>
                                                <strong>Rejection Send To:</strong>
                                                <span className="required-field">*</span>
                                            </th>

                                            <td>
                                                <Input
                                                    type="select"
                                                    value={selectedInvoice?.rejectionSendTo || ""}
                                                   // {/*disabled={isInitial || isApproved || isFinalStatus} */} // ✅ key logic
                                                    disabled={!isRejected || isFinalStatus}
                                                    onChange={(e) => {
                                                        const value = e.target.value;   // ✅ FIX HERE

                                                        setSelectedInvoice(prev => ({
                                                            ...prev,
                                                            rejectionSendTo: value
                                                        }));

                                                        setRejectionSendToError("");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="4">Security</option>
                                                    <option value="5">Vendor</option>
                                                </Input>

                                                {!isFinalStatus && isRejected && rejectionSendToError && (
                                                    <div className="text-danger">{rejectionSendToError}</div>
                                                )}
                                            </td>

                                            <th></th>
                                            <td></td>
                                        </tr>
                                    )}
                                    {/* ================= APPROVED SECTION ================= */}
                                    {isApproved && (
                                        <>
                                            <tr>
                                                <th><strong>Supplier Type:</strong><span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        value={selectedInvoice?.supplierType || ""}
                                                        disabled={isFinalStatus}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setSelectedInvoice(prev => ({
                                                                ...prev,
                                                                supplierType: value,
                                                                departmentHead: "",
                                                                verifier: ""
                                                            }));
                                                            setSupplierTypeError("");

                                                            if (value) {
                                                                axios.get(`/department/department-heads/${value}`)
                                                                    .then(res => {
                                                                        console.log("Dept heads:", res.data);
                                                                        setDepartmentHeads(res.data || []);
                                                                    })
                                                                    .catch(err => console.error("Error fetching dept heads:", err));

                                                                axios.get(`/department/verifiers/${value}`)
                                                                    .then(res => {
                                                                        console.log("Verifiers:", res.data);
                                                                        setVerifiers(res.data || []);
                                                                    })
                                                                    .catch(err => console.error("Error fetching verifiers:", err));
                                                            } else {
                                                                setDepartmentHeads([]);
                                                                setVerifiers([]);
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        {(supplierTypes ?? []).map((item) => (
                                                            <option key={item.id} value={String(item.id)}>
                                                                {item.type}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {supplierTypeError && (
                                                        <div className="text-danger">{supplierTypeError}</div>
                                                    )}
                                                </td>

                                                <th><strong>Department Head:</strong><span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        value={selectedInvoice?.departmentHead || ""}
                                                        disabled={isFinalStatus}
                                                        onChange={(e) => {
                                                            const value = e.target.value;  // ✅ capture immediately
                                                            setSelectedInvoice(prev => ({ ...prev, departmentHead: value }));
                                                            setDepartmentHeadError("");
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        {(departmentHeads ?? []).map((head) => (
                                                            <option key={head.empId} value={head.empId}>
                                                                {head.userName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {departmentHeadError && (
                                                        <div className="text-danger">{departmentHeadError}</div>
                                                    )}
                                                </td>
                                            </tr>

                                                <tr>
                                                    <th>
                                                        <strong>Verifier Name:</strong>
                                                        <span className="required-field">*</span>
                                                    </th>
                                                    <td>
                                                        <Input

                                                            type="select"

                                                            value={selectedInvoice?.verifier || ""}

                                                            disabled={isFinalStatus}

                                                            onChange={(e) => {

                                                                const value = e.target.value;

                                                                setSelectedInvoice(prev => ({

                                                                    ...prev,

                                                                    verifier: value

                                                                }));

                                                                setVerifierError("");

                                                            }}
                                                        >
                                                            <option value="">Select</option>

                                                            {(verifiers ?? []).map((verifier) => (
                                                                <option key={verifier.empId} value={verifier.empId}>

                                                                    {verifier.userName}
                                                                </option>

                                                            ))}
                                                        </Input>

                                                        {!isFinalStatus && verifierError && (
                                                            <div className="text-danger">

                                                                {verifierError}
                                                            </div>

                                                        )}
                                                    </td>
                                                </tr>


                                            {/* File Upload Row */}
                                            <tr>
                                                <th><strong>Vendor Evaluation Form:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="EvaluationForm"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.evaluationForm && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.evaluationForm,
                                                                poFiles.evaluationForm?.split("/").pop(),
                                                                "Vendor Evaluation Form Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>

                                                <th><strong>Comparison Quotes:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="ComparisonQuotes"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.comparisonQuotes && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.comparisonQuotes,
                                                                "Comparison Quotes",
                                                                "Comparison Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th><strong>Email Approval:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="EmailApproval"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.emailApproval && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.emailApproval,
                                                                /*poFiles.emailApproval?.split("/").pop(),*/
                                                                "Email Approval",
                                                                "Email Approval Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>

                                                <th><strong>Invoice:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="Invoice"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.invoice && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.invoice,
                                                                /*  poFiles.invoice?.split("/").pop(),*/
                                                                "Invoice",
                                                                "Invoice Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                </tr>


                                            <tr>
                                                    <th>
                                                        <strong>
                                                            PO:
                                                            {!isAgreement && (
                                                                <span className="required-field">*</span>
                                                            )}
                                                        </strong>
                                                    </th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="PO"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />


                                                    {poFiles?.po && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.po,
                                                                /* poFiles.po?.split("/").pop(),*/
                                                                "PO DOC",
                                                                "PO Document Preview"
                                                            )}
                                                        </div>
                                                    )}


                                                        {!isFinalStatus && !isAgreement && poError && (
                                                            <div className="text-danger">{poError}</div>
                                                        )}
                                                </td>

                                                    <th>
                                                        <strong>
                                                            PR:
                                                            {!isAgreement && (
                                                                <span className="required-field">*</span>
                                                            )}
                                                        </strong>
                                                    </th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="PR"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.pr && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.pr,
                                                                /* poFiles.pr?.split("/").pop(),*/
                                                                "PR DOC",
                                                                "PR Document Preview"
                                                            )}
                                                        </div>
                                                    )}

                                                        {!isFinalStatus && !isAgreement && prError && (
                                                            <div className="text-danger">{prError}</div>)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th><strong>Quotation 1:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="Quotation1"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.quotation1 && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.quotation1,
                                                                /* poFiles.quotation1?.split("/").pop(),*/
                                                                "Quotation1",
                                                                "Quotation 1 Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>

                                                <th><strong>Quotation 2:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="Quotation2"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.quotation2 && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.quotation2,
                                                                /*poFiles.quotation2?.split("/").pop(),*/
                                                                "Quotation2",
                                                                "Quotation 2 Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th><strong>Quotation 3:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="Quotation3"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.quotation3 && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.quotation3,
                                                                /*  poFiles.quotation3?.split("/").pop(),*/
                                                                "Quotation3",
                                                                "Quotation 3 Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>

                                                <th><strong>Other Documents:</strong></th>
                                                <td>
                                                    <Input
                                                        type="file"
                                                        name="OtherDocuments"
                                                        disabled={isFinalStatus}
                                                        onChange={handleFileChange}
                                                    />

                                                    {poFiles?.otherDocuments && (
                                                        <div style={{ marginTop: "6px" }}>
                                                            {renderDocumentFile(
                                                                poFiles.otherDocuments,
                                                                /*     poFiles.otherDocuments?.split("/").pop(),*/
                                                                "otherDocuments",
                                                                "Other Documents Preview"
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                </tbody>

                                </Table>
                                <ModalFooter>
                                    {/*<Button color="success" onClick={handleSaveStatus}>Save</Button>*/}
                                {!isFinalStatus && (
                                    <Button color="success" onClick={handleSaveStatus}>
                                        Save
                                    </Button>
                                )}
                                    <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                                </ModalFooter>
                 </>
                        )}
                    {/* Vendor Info Tab */}
                        {activeTab === "info" && selectedVendor && (

                        <VendorInfoTabs
                            selectedVendor={selectedVendor}   // Vendor object
                            vendorFiles={files}               // Vendor files fetched above
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            handleInputChange={(e, field) =>
                                setSelectedVendor({ ...selectedVendor, [field]: e.target.value })
                            }
                            subTab={subTab}
                            setSubTab={setSubTab}
                            type="invoice"
                        />
                    )}

                    {activeTab === "infoInvoice" && invoiceInfo && (
                        <>
                                <Table bordered className="info-table1 invoice-info-table">                               
                                <tbody>
                                    <tr>
                                        <th><strong>Invoice Type:</strong></th>
                                        <td>{invoiceInfo.invoiceType || "N/A"}</td>
                                        <th><strong>Supplier Type:</strong></th>
                                        <td>
                                            {invoiceInfo.invoiceSupplierType === 1
                                                ? "Supply of Goods"
                                                : invoiceInfo.invoiceSupplierType === 2
                                                    ? "Supply of Service"
                                                    : "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><strong>Invoice Document:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.invoiceFilePath,
                                                invoiceInfo.fileName,
                                                "Invoice Document Preview"
                                            )}
                                        </td>
                                        <th><strong>Invoice Date:</strong></th>
                                        <td>
                                            {invoiceInfo.invoiceDate
                                                ? new Date(invoiceInfo.invoiceDate).toLocaleDateString("en-GB")
                                                : "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Invoice No:</strong></th>
                                        <td>{invoiceInfo.invoiceNo || "N/A"}</td>
                                        <th><strong>PO No:</strong></th>
                                        <td>{invoiceInfo.pono || "N/A"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>Delivery Challan No:</strong></th>
                                        <td>{invoiceInfo.deliveryChallanNumber || "N/A"}</td>
                                        <th><strong>Invoice Value:</strong></th>
                                        <td>{invoiceInfo.invoiceValue?.toFixed(2) || "0.00"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>IGST:</strong></th>
                                        <td>{invoiceInfo.igst?.toFixed(2) || "0.00"}</td>
                                        <th><strong>CGST:</strong></th>
                                        <td>{invoiceInfo.cgst?.toFixed(2) || "0.00"}</td>
                                    </tr>

                                    <tr>
                                        <th><strong>SGST:</strong></th>
                                        <td>{invoiceInfo.sgst?.toFixed(2) || "0.00"}</td>
                                        <th><strong>Total Value:</strong></th>
                                        <td>{invoiceInfo.totalValue?.toFixed(2) || "0.00"}</td>

                                    </tr>

                                    <tr>
                                        <th><strong>Created Date:</strong></th>
                                        <td>
                                            {invoiceInfo.createdDate
                                                ? new Date(invoiceInfo.createdDate).toLocaleDateString("en-GB")
                                                : "N/A"}
                                        </td>
                                        <th><strong>Agreement Document:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.agreementFilePath,
                                                invoiceInfo.fileNameAgreement,
                                                "Agreement Document Preview"
                                            )}
                                        </td>
                                    </tr>

                                    {/*<tr>*/}
                                    {/*    <th><strong>Email Approval:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.emailApproval ? (*/}
                                    {/*            <a href={invoiceInfo.emailApproval} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*    <th><strong>Invoice:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.Invoice ? (*/}
                                    {/*            <a href={invoiceInfo.invoice} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*</tr>*/}
                                    <tr>
                                        <th><strong>Email Approval:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.emailApprovalFilePath,
                                                "Email Approval",
                                                "Email Approval Preview"
                                            )}
                                        </td>

                                        <th><strong>Invoice (PO Upload):</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.invoiceIMAGEFilePath,
                                                "Invoice Document",
                                                "Invoice Preview"
                                            )}
                                        </td>
                                    </tr>
                                    {/*<tr>*/}
                                    {/*    <th><strong>PO Attachment:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.poAttachment ? (*/}
                                    {/*            <a href={invoiceInfo.poAttachment} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*    <th><strong>PR Attachment:</strong></th>*/}
                                    {/*    <td>*/}
                                    {/*        {invoiceInfo.prAttachment ? (*/}
                                    {/*            <a href={invoiceInfo.prAttachment} target="_blank" rel="noopener noreferrer">*/}
                                    {/*                View*/}
                                    {/*            </a>*/}
                                    {/*        ) : "N/A"}*/}
                                    {/*    </td>*/}
                                    {/*</tr>*/}
                                    <tr>
                                        <th><strong>PO Attachment:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.poimageFilePath,
                                                "PO Document",
                                                "PO Preview"
                                            )}
                                        </td>

                                        <th><strong>PR Attachment:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.primageFilePath,
                                                "PR Document",
                                                "PR Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Quotation:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotationIMAGEFilePath,
                                                "Quotation 1",
                                                "Quotation Preview"
                                            )}
                                        </td>
                                        <th><strong>More Quotation:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotation2IMAGEFilePath,
                                                "Quotation 2",
                                                "Quotation Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        {/*<th><strong>Comparison Quotes:</strong></th>*/}
                                        {/*<td>*/}
                                        {/*    {invoiceInfo.comparisonDocument ? (*/}
                                        {/*        <a href={invoiceInfo.comparisonDocument} target="_blank" rel="noopener noreferrer">*/}
                                        {/*            View*/}
                                        {/*        </a>*/}
                                        {/*    ) : "N/A"}*/}
                                        {/*</td>*/}
                                        <th><strong>Comparison Quotes:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.comparisonquotesFilePath,
                                                "Comparison Quotes",
                                                "Comparison Preview"
                                            )}
                                        </td>
                                        <th><strong>Evaluation Form:</strong></th>
                                        <td>
                                            {invoiceInfo.evaluationForm ? (
                                                <a href={invoiceInfo.evaluationForm} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>Other Documents:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.otherDocuementsIMAGEFilePath,
                                                "Other Documents",
                                                "Other Documents Preview"
                                            )}
                                        </td>
                                        <th><strong>TimeSheet:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.timeSheetFilePath,
                                                invoiceInfo.fileNameTimeSheet,
                                                "TimeSheet Preview"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><strong>GRN Attachment:</strong></th>
                                        <td>
                                            {invoiceInfo.grnAttachment ? (
                                                <a href={invoiceInfo.grnAttachment} target="_blank" rel="noopener noreferrer">
                                                    View
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                        <th><strong>Quotation 3:</strong></th>
                                        <td>
                                            {renderDocumentFile(
                                                invoiceInfo.poDocuments?.quotation3IMAGEFilePath,
                                                "Quotation 3",
                                                "Quotation 3 Preview"
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        
                            {/* GRN Items Section */}
                            <h5 className="text-primary fw-bold mb-3">
                                The Following goods has been Received.
                            </h5>

                            <table className="table table-bordered align-middle table-hover invoice-table">
                                <thead className="table-header text-center">
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Description</th>
                                        <th>Ordered Qty</th>
                                        <th>Supplied Qty</th>
                                        <th>Invoice Value</th>
                                        <th>CGST (%)</th>
                                        <th>SGST (%)</th>
                                        <th>IGST (%)</th>
                                        <th>Total Value</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceInfo?.grnItems?.length > 0 ? (
                                        invoiceInfo.grnItems.map((item, index) => (
                                            <tr key={item.id} className="text-center">
                                                <td>{index + 1}</td>
                                                <td className="text-start">{item.description || "-"}</td>
                                                <td>{item.qty ?? 0}</td>
                                                <td>{item.rcvQty ?? 0}</td>
                                                <td>{item.invoiceValue?.toFixed(2) ?? "0.00"}</td>
                                                <td>{item.cgst ?? 0}</td>
                                                <td>{item.sgst ?? 0}</td>
                                                <td>{item.igst ?? 0}</td>
                                                <td>{item.totalValue?.toFixed(2) ?? "0.00"}</td>
                                                <td>{item.remark || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: "center" }}>No GRN Items Available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            </>
                    )}

                        {activeTab === "history" && (
                            <div className="history-container1">
                              {historyData.length === 0 ? (
                                <div className="history-empty-state">
                                    <div className="history-empty-icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="9" />
                                            <polyline points="12 7 12 12 15 14" />
                                        </svg>
                                    </div>
                                    <h4 className="history-empty-title">No Approval History</h4>
                                    <p className="history-empty-text">
                                        No approval actions have been performed on this invoice yet.
                                    </p>
                                </div>
                              ) : (
                                <table className="history-table1">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Approval Status</th>
                                            <th>Approver Name</th>
                                            <th>Date</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyData.length > 0 ? (
                                            historyData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.approvalStatus || "N/A"}</td> {/* lowercase */}
                                                    <td>{item.approvalname || "N/A"}</td>
                                                    <td>
                                                        {item.createdate
                                                            ? new Date(item.createdate).toLocaleDateString("en-GB")
                                                            : "N/A"}
                                                    </td>
                                                    <td>{item.comments || "N/A"}</td>
                                                </tr>
                                            ))
                                        ) : null}
                                    </tbody>
                                </table>
                              )}
                            </div>
                        )}

                </ModalBody>
                {/* 🔵 Preview Modal */}
                <Modal
                    isOpen={showPreview}
                    toggle={() => setShowPreview(false)}
                    size="lg"
                    centered
                >
                    <ModalHeader toggle={() => setShowPreview(false)}>
                        {previewTitle}
                    </ModalHeader>

                    <ModalBody style={{ padding: 0 }}>
                        {previewUrl ? (
                            <iframe
                                src={previewUrl}
                                title="Preview"
                                style={{
                                    width: "100%",
                                    height: "80vh",
                                    border: "none"
                                }}
                            />
                        ) : (
                            <p style={{ padding: "20px" }}>No preview available</p>
                        )}
                    </ModalBody>
                </Modal>

                </Modal>

            </DashboardLayout>
        </>
    );

};
export default ViewAllInvoicesPO;
